export default "__VITE_ASSET__qDbgjdMw__"